'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (store, layout) {
    var metaData = store.data.metaData;
    var dimensionName = layout.rows[0].dimension;

    var dimensionIds = (0, _isArray2.default)(metaData.dimensions[dimensionName]) ? metaData.dimensions[dimensionName] : [];

    return dimensionIds.map(function (id) {
        return metaData.items[id].name;
    });
};

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
//# sourceMappingURL=getCategories.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getCategories.js
 ** module id = 90
 ** module chunks = 0 1
 **/